import {
  selectIsCampaignPerformanceAlertsFeatureFlagOn,
  selectIsCampaignPerformanceAlertsHistoryFeatureFlagOn,
} from 'core/userContext/selectors';
import _compact from 'lodash/compact';
import { Campaign } from 'modules/domains/campaign';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { OverflowMenu } from 'ui/actionMenu';
import { StyledOptions } from 'ui/actionMenu/ActionMenu.styles';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { BUTTON_SIZES } from 'ui/button';
import { PerformanceAlerts16, View16 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { getCampaignDetailsLink } from '../utils';

export const CAMPAIGN_ANALYTICS_OVERFLOW_MENU_TEST_ID = 'campaign-analytics-overflow-menu';
export const VIEW_CAMPAIGN_OPTION_TEST_ID = 'view-campaign';
export const VIEW_ALERTS_OPTION_TEST_ID = 'view-alerts';

const OverflowMenuItem = styled.div`
  gap: ${spacing.half};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledOverflowMenu = styled(OverflowMenu)`
  ${StyledOptions} {
    width: ${pxToRem(188)};
  }
`;

export const CampaignAnalyticsOverflowMenu = ({
  campaignMetadata,
  onViewAlerts,
}: {
  campaignMetadata: Partial<Campaign>;
  onViewAlerts: () => void;
}) => {
  const isCampaignPerformanceAlertsFeatureEnabled = useSelector(
    selectIsCampaignPerformanceAlertsFeatureFlagOn,
  );
  const isCampaignPerformanceAlertsHistoryFeatureEnabled = useSelector(
    selectIsCampaignPerformanceAlertsHistoryFeatureFlagOn,
  );

  const campaignId = campaignMetadata?.id;

  const options = _compact([
    {
      id: VIEW_CAMPAIGN_OPTION_TEST_ID,
      as: AllowedActionMenuElements.Link,
      content: (
        <OverflowMenuItem>
          <View16 color={colors.iconSubtle} />
          View campaign
        </OverflowMenuItem>
      ),
      href: getCampaignDetailsLink({
        campaignMetadata,
        campaignId,
      }),
    },
    isCampaignPerformanceAlertsFeatureEnabled &&
      isCampaignPerformanceAlertsHistoryFeatureEnabled && {
        as: AllowedActionMenuElements.Button,
        content: (
          <OverflowMenuItem>
            <PerformanceAlerts16 color={colors.iconSubtle} />
            View alerts
          </OverflowMenuItem>
        ),
        id: VIEW_ALERTS_OPTION_TEST_ID,
        onClick: onViewAlerts,
      },
  ]);

  return (
    <>
      {options.length > 0 && (
        <StyledOverflowMenu
          size={BUTTON_SIZES.LARGE}
          options={options}
          id={CAMPAIGN_ANALYTICS_OVERFLOW_MENU_TEST_ID}
          data-test={CAMPAIGN_ANALYTICS_OVERFLOW_MENU_TEST_ID}
        />
      )}
    </>
  );
};
